// Заголовки для очереди «Внимание» и для полосы разбора в диалоге.
//
// Технический reason пишется в базу как есть (он нужен для eval и аналитики), а человеку
// показывается перевод. Раньше перевод жил в двух местах - в api и в панели - и расходился:
// одна и та же эскалация называлась по-разному в списке и в диалоге. Теперь функция одна.
//
// Формулировки - от лица владельца и про то, ЧТО ПРОИЗОШЛО, а не про то, как устроен агент.
// «Модель запросила человека» - это фраза разработчика; управляющему нужно «Smena просит
// вас ответить».

import { INTENT_LABEL_RU } from './autonomy-labels';

const EXACT: Record<string, string> = {
  unclear: 'Непонятный вопрос',
  'hard-stop': 'Деньги или спор - только человек',
  'low-confidence': 'Smena не уверена в ответе',
  llm_off: 'Ответы своими словами на паузе',
  'модель запросила человека': 'Smena просит вас ответить',
};

/** Человеческий заголовок эскалации. Вход - reason из EscalationStore. */
export function escalationTitleRu(reason: string): string {
  const stripped = String(reason ?? '')
    .replace(/\s*\(mock\)\s*$/, '')
    .trim();
  if (!stripped) return 'Нужен ваш ответ';
  if (EXACT[stripped]) return EXACT[stripped]!;

  if (stripped.startsWith('hard-stop:')) return 'Деньги или спор - только человек';
  if (stripped.startsWith('низкая уверенность')) return 'Smena не уверена в ответе';
  if (stripped.startsWith('kb_gap:')) {
    const gap = stripped.slice('kb_gap:'.length).trim().replace(/^["«](.+)["»]$/, '$1');
    return gap ? `Нет ответа в базе: ${gap}` : 'Нет ответа в базе знаний';
  }

  // Прочее вида «префикс: человеческий текст» - показываем только текст.
  const colon = stripped.indexOf(': ');
  if (colon > 0 && colon < stripped.length - 2) {
    return stripped.slice(colon + 2).trim().replace(/^["«](.+)["»]$/, '$1');
  }
  return stripped;
}

/** Заголовок черновика в очереди: тема вопроса словами, а не кодом интента. */
export function draftTitleRu(intent: string): string {
  const label = INTENT_LABEL_RU[intent]?.title;
  return label ? `Ответ на тему «${label}»` : 'Ответ ждёт проверки';
}
